module.exports = {
	model: {
		dataJSON: {},
		type: null,
		value: null,
		pickerConfig: {}
	},
	
	methods: {
		onBuild: function(){
			this.prepareConfigs();
		},

		prepareConfigs: function(){
			var fieldConfig = this.model.config || {};
			var pickerConfigList = fieldConfig.pickerConfigList || {};

			var toggleModel = this.model.toggleModel = {
				dataTEXT: '',
				fieldCode: 'type',
				atom: {
					dataType: 'text'
				},
				aliases: {},
				'text-data': [],
			}

			var selectedConfigKey = ''
			for(var configKey in pickerConfigList){
				selectedConfigKey = selectedConfigKey || configKey;

				var pickerConfig = pickerConfigList[configKey] || {}
				if(pickerConfig.icon){
					toggleModel.aliases[configKey] = {
						name: pickerConfig.icon,
						type: 'symbol'
					}
				}
				if(pickerConfig.default){
					selectedConfigKey = configKey;
				}

				var name = ''
				if(pickerConfig.nameKey){
					name = storage.__(pickerConfig.nameKey)
				}
				toggleModel['text-data'].push({
					name,
					value: configKey,
				})
			}

			this.model.dataJSON = this.model.dataJSON || {}
			var type =
				this.model.type =
				this.model.dataJSON.type =
				toggleModel.dataTEXT =
					this.model.dataJSON.type || selectedConfigKey
			;
			this.model.pickerConfig = (pickerConfigList[type] || {}).airDateTimePickerConfig || {}
			this.model.value = this.model.dataJSON.value || null
		},

		onChange: function(type, value, refreshGranted = true){
			var self = this;
			var changeFound = false;
			var valueChanged = false;

			if(type !== undefined && this.model.type !== type){
				this.model.type = type;
				this.model.toggleModel.dataTEXT = type;
				this.model.pickerConfig = (((this.model.config || {}).pickerConfigList || {})[type] || {}).airDateTimePickerConfig || this.model.pickerConfig;
				this.model.pickerConfig.forceFirstChangePropagation = refreshGranted;
				changeFound = true;
			}
			if(value !== undefined && this.model.value !== value){
				this.model.value = value;
				changeFound = valueChanged = true;
			}

			if(changeFound && refreshGranted){
				if(valueChanged){
					this.parent(function(parentComponent){
						parentComponent.trigger('onChildChanged', {
							fieldCode: self.model.fieldCode,
							value: {
								type: self.model.type,
								value: self.model.value
							}
						});
					});
				}

				this.refresh(false)
			}
		},
	},

	hooks: {
		onChildChanged: function($element, options){
			if(options.fieldCode === 'type'){
				this.onChange(options.value, undefined);
			} else if (options.fieldCode === 'value'){
				this.onChange(undefined, options.value);
			}
		}
	}
};
